export const required = (field) => `請填寫${field}`;
export const numeric = (field) => `${field} 必須是數字`;
export const decimal = (field) => `${field} 必須是數字`;
export const length = (field) => `${field}長度不正確`;
export const isNot = (field) => `請選擇${field}`;
